import styled from '@emotion/styled';

const FlexContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export default FlexContainer;
